export const getEventCardBGColor = (name) => {
  let cardColor, buttonColor;

  switch (name) {
    case "SCORE":
      cardColor = "#DFEFFF";
      buttonColor = "#699BE6";
      break;
    case "Hots Olympiad":
      cardColor = "#FFEAD7";
      buttonColor = "#E49852";
      break;
    case "HOTSOLYMPIAD":
      cardColor = "#FFEAD7";
      buttonColor = "#E49852";
      break;
    case "Math Olympiad":
      cardColor = "#E8FBFA";
      buttonColor = "#52AEAC";
      break;
    case "English Olympiad":
      buttonColor = "#CB6998";
      cardColor = "#FFE9F4";
      break;
    case "WIT":
      cardColor = "#EDE8FF";
      buttonColor = "#8A75CA";
      break;
    case "I-EMSAT":
      cardColor = "#FFE6EE";
      buttonColor = "#D276AF";
      break;
    case "Career Counselling":
      cardColor = "#EDE8FF";
      buttonColor = "#8A75CA";
      break;
    case "Atreya Scholarship Test":
      cardColor = "#DFEFFF";
      buttonColor = "#699BE6";
      break;
    case "SCORE Edge Scholarship Test":
      cardColor = "#DFEFFF";
      buttonColor = "#699BE6";
      break;
    case "Score Edge":
      cardColor = "#DFEFFF";
      buttonColor = "#699BE6";
      break;
    case "Revision Test":
      cardColor = "#DECCFF";
      buttonColor = "#573793";
      break;
    default:
      cardColor = "#FFEAD7";
      buttonColor = "#E49852";
      break;
  }

  return { cardColor, buttonColor };
};
